import dayjs from 'dayjs';
import { TFunction } from 'i18next';

import { ISignal } from '@aqx-core/common/api/signal';
import { ESignalFilter } from '@aqx-core/common/constants/signal';
import { i18n } from '@aqx-core/common/i18n';
import { safeT } from '@aqx-core/common/utils/i18n';

export const mapSignalFilterToLabel = (filter: ESignalFilter, t: TFunction = i18n.t): string => {
  const translate = safeT(t);

  switch (filter) {
    case ESignalFilter.ALL:
      return translate('Signal List');
    case ESignalFilter.FAVOURITE:
      return translate('Favorite Signals');
    default:
      return filter;
  }
};

export const filterSignalsByKeyword = (keyword: string, signals: ISignal[]): ISignal[] => {
  if (!keyword.trim()) {
    return signals;
  }

  const trimmedKeyword = keyword.toLowerCase().trim();

  return signals.filter(({ symbol, description }) => {
    const matchSymbol = symbol.toLowerCase().includes(trimmedKeyword);
    const matchDescription = description.toLowerCase().includes(trimmedKeyword);

    return matchSymbol || matchDescription;
  });
};

export const signalSorter = (a: ISignal, b: ISignal): number => {
  if (a.isDisplay === false) {
    return 1;
  }

  if (b.isDisplay === false) {
    return -1;
  }

  if (a.publishedDate > b.publishedDate) {
    return -1;
  }

  if (a.publishedDate < b.publishedDate) {
    return 1;
  }

  return 0;
};

export const sortSignals = (signals: ISignal[]): ISignal[] => {
  return [...signals].sort(signalSorter);
};

export const getSignalUniqueId = (signal: ISignal): string => {
  return signal.uniqueId || `${signal.id}-${signal.symbol}`;
};

export const formatDate = (timestamp: number) => {
  const isSameDay = dayjs().isSame(dayjs(timestamp), 'day');
  if (isSameDay) {
    return dayjs(timestamp).format('HH:mm');
  }
  return dayjs(timestamp).format('YYYY-MM-DD');
};

export const shouldBlurSignal = (signal: ISignal): boolean => {
  return !signal.isDisplay;
};

/**
 * Gets the index of the first signal that should be blurred
 * This can be used to show a banner/overlay at the appropriate position
 */
export const getFirstBlurredSignalIndex = (signals: ISignal[]): number => {
  return signals.findIndex((signal) => !signal.isDisplay);
};
